import React, { useEffect } from "react";
import { createBrowserHistory } from 'history';
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import {axiosInstance} from '../../utils/axiosInstance';
import { MdOutlineShoppingCart } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import MdAccountCircle from "assets/img/profile/user.png"

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const [notificationList, setNotificationList] = React.useState([]);
  const history = createBrowserHistory();

  const handleLogOut = () => {
    localStorage.removeItem('token');
    history.push('/auth');
    window.location.reload();
  }
  useEffect(() => {
    setNotificationList([]);
    const fetchNotifs = async () => {
      try {
        const response = await axiosInstance.get('api/Request/GetRequests', {
          params: {
            filter: "new",
            productType: "all"
          }
        });
        setNotificationList(response.data);
      } catch (error) {
        // console.log("error in getting notifiations :", error.response.data);
      }
    }
    fetchNotifs();
  }, [])

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ms-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            صفحات
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="text-xl pe-2 ps-3">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className={`h-4 w-4 ${notificationList.length > 0 ? 'text-red-600' : 'text-gray-600 dark:text-white'}`} />
            </p>
          }
          animation="origin-top-end  transition-all duration-300 ease-in-out"
          children={
            <div className={`flex flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px] max-h-64 ${notificationList.length>3 ? 'overflow-y-scroll': ''}`}>
              <div className="flex items-center justify-between ">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  {notificationList.length > 0 ?
                    'اعلان های جدید'
                    :
                    'اعلان جدیدی موجود نیست'}

                </p>
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                </p>
              </div>
              {notificationList.map((item, index) =>
              (
                <button className="flex w-full items-center" key={index}>
                  <div className="flex h-full w-[22%] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                    <MdOutlineShoppingCart  />
                  </div>
                  <div className="flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm ms-2">
                    <p className="mb-1 text-base font-bold text-gray-900 text-start dark:text-white">
                      درخواست {item.product.name}
                    </p>
                    <p className="font-base text-xs text-gray-900 text-start dark:text-white">
                      نام ونام خانوادگی: <b>{item.firstName} {item.lastName}</b> | تلفن :<b>{item.phoneNumber}</b>
                    </p>
                  </div>
                </button>
              )
              )}


            </div>
          }
          classNames={"py-2 top-4 left-0 -start-[230px] md:-start-[440px] w-max"}
        />
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full transition-all duration-100 hover:cursor-pointer hover:border-4 hover:border-gray-400"
              src={MdAccountCircle}
              alt="Elon Musk"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
            <div className="p-4">
              <div className="flex items-center gap-2">
                <p className="text-sm font-bold text-center text-navy-700 dark:text-white">
                  👋 خوش آمدید
                </p>{" "}
              </div>
            </div>
            <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

            <div className="flex flex-col p-4  rounded-b-[20px] hover:bg-gray-200">

              <button
                onClick={handleLogOut}
                className="mt-3 text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in "
              >
                خروج از حساب
              </button>
            </div>
          </div>
          }
          classNames={"py-2 top-8 left-0 -start-[180px] w-max"}
          animation="origin-[75%_0%] md:origin-top-end transition-all duration-300 ease-in-out"
        />
      </div>
    </nav>
  );
};

export default Navbar;
